import merge from "lodash.merge";
import { TypeSollicitation } from "../apis/monsisra/generated";

export class UtilsService {
	deepMerge = merge;

	getDefaultType() {
		return window.location.pathname.includes("ressource") ? TypeSollicitation.DemandeAppui : TypeSollicitation.TeleExpertise;
	}

	static getAuthRedirectPath(): string {
		// On retire le chemin de base de déploiement ('/teleexpertise') pour obtenir le chemin relatif **dans l'application** (ex: '/expert'), afin de pouvoir y revenir après l'authentification
		const relativePath = window.location.pathname.substring(window.config.deployedPath.length);
		// On récupère les paramètres de la query string (ex: '?IdTechPsCible=121a8c0f...')
		const queryParams = window.location.search;
		// On reconstruit le chemin complet (ex: '/expert?IdTechPsCible=...')
		return relativePath + queryParams;
	}

	static generateGUID(): string {
		return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
			const r = (Math.random() * 16) | 0;
			const v = c === "x" ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
	}
}